import { connect } from "react-redux";
// API
import api from "api";
// Action
import { openErrorDialog } from "redux/modules/errorDialog";
import {
  openConfirmDialog,
  closeConfirmDialog
} from "redux/modules/confirmDialog";
import { showSnackbar } from "redux/modules/snackbar";
import { openMessageDialog } from "redux/modules/messageDialog";
import {
  changeCustomerForm,
  closeCustomerModal,
  setErrors,
  changeSelectedLocales
} from "redux/modules/customerModal";

// Component
import CustomerModal from "components/CustomerModal";
// asset data
import Attrs from "assets/data/AttributeData";

const mapStateToProps = state => ({
  customerModal: state.customerModal,
  allLocales: state.customerList.allLocales,
  industries: state.customerList.industries,
  title: "顧客登録",
  btnLabel: "登録"
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  // フォームの変更
  changeCustomerForm: (key, value) => {
    // 従業員数の桁数を制限
    if (key === "employees" && value.length > 5) {
      return;
    }

    dispatch(changeCustomerForm(key, value));
  },
  // 言語の選択
  changeSelectedLocales: (value, key) => {
    if (key === "ja") {
      dispatch(openMessageDialog("日本語を外すことはできません。"));
    } else {
      dispatch(changeSelectedLocales(value));
    }
  },
  // 閉じる
  handleClose: () => dispatch(closeCustomerModal()),
  // 登録
  handleRegister: customer => {
    const errors = customer.validation();
    if (errors.length > 0) {
      dispatch(setErrors(errors));
      return;
    }

    const params = {
      customer_modal: {
        customer: customer.toJS(),
        selectedLocaleIds: customer.get("selectedLocaleIds")
      },
      defaultAttrs: Attrs()
    };

    const dialogData = {
      title: "確認",
      contentText: "顧客を登録します。よろしいですか？",
      btnLabel: "登録",
      handleClick: () => {
        api
          .post(`customer_modal`, params)
          .then(res => {
            dispatch(closeConfirmDialog());

            if (res.errors) {
              dispatch(setErrors(res.errors));
            } else {
              dispatch(closeCustomerModal());
              dispatch(showSnackbar("顧客を登録しました。"));
              ownProps.fetchCustomerList();
            }
          })
          .catch(error => dispatch(openErrorDialog(error)));
      }
    };

    dispatch(setErrors([]));
    dispatch(openConfirmDialog(dialogData));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomerModal);



// WEBPACK FOOTER //
// ./src/containers/CustomerList/CustomerModalContainer.js